"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculatePayrollTotalGross = exports.calculateEarningAmount = exports.calculateOvertimeEarningAmount = exports.grossEarnings = exports.calculateOvertimeEarningsGross = exports.calculateOvertimeEarningsBaseRate = exports.calculateTotalNonHourlyEarningsGross = exports.calculateTotalHourlyEarningsGross = exports.getOvertimePayRateDependentEarnings = exports.calculateOvertimeDependentTotalHours = void 0;
const currency_1 = __importDefault(require("@bambeehr/currency"));
const union_1 = __importDefault(require("lodash/union"));
const earning_types_1 = require("../constants/earning-types");
const toHourlyRate_1 = __importDefault(require("./toHourlyRate"));
const OVERTIME_EARNING_TYPES = [earning_types_1.EarningType.OVERTIME.value, earning_types_1.EarningType.DOUBLE_OVERTIME.value];
const HOURLY_EARNING_TYPES = [
    earning_types_1.EarningType.AMOUNT_TIME.value,
    earning_types_1.EarningType.HOURLY.value,
    earning_types_1.EarningType.PAID_HOLIDAY.value,
    earning_types_1.EarningType.PAID_HOLIDAY_1_5X.value,
    earning_types_1.EarningType.PTO.value,
    earning_types_1.EarningType.SALARIED.value,
    earning_types_1.EarningType.SICK.value,
];
const NON_HOURLY_EARNING_TYPES = [
    earning_types_1.EarningType.AMOUNT_VALUE.value,
    earning_types_1.EarningType.BONUS.value,
    earning_types_1.EarningType.CASH_TIPS.value,
    earning_types_1.EarningType.COMMISSION.value,
    earning_types_1.EarningType.GROUP_TERM_LIFE.value,
    earning_types_1.EarningType.OTHER_IMPUTED.value,
    earning_types_1.EarningType.PAYCHECK_TIPS.value,
    earning_types_1.EarningType.REIMBURSEMENT.value,
    earning_types_1.EarningType.SEVERANCE.value,
    earning_types_1.EarningType.NON_HOURLY_REGULAR,
    earning_types_1.EarningType.ALLOWANCE,
    earning_types_1.EarningType.REPORTED_ALLOWANCE,
    earning_types_1.EarningType.CLERGY_HOUSING,
    earning_types_1.EarningType.REPORTED_CLERGY_HOUSING,
];
function calculateOvertimeDependentTotalHours(earnings = []) {
    const TOTAL_HOUR_DEPENDENCY_TYPES = [
        earning_types_1.EarningType.HOURLY.value,
        earning_types_1.EarningType.PAID_HOLIDAY.value,
        earning_types_1.EarningType.PAID_HOLIDAY_1_5X.value,
        earning_types_1.EarningType.SALARIED.value,
    ];
    return earnings
        .filter((earning) => TOTAL_HOUR_DEPENDENCY_TYPES.includes(earning.type))
        .reduce((hours, earning) => {
        const earningHours = earning.minutes / 60;
        return hours + earningHours;
    }, 0);
}
exports.calculateOvertimeDependentTotalHours = calculateOvertimeDependentTotalHours;
function getOvertimePayRateDependentEarnings(earnings = [], exclude = []) {
    const original = [
        earning_types_1.EarningType.HOURLY.value,
        earning_types_1.EarningType.SALARIED.value,
        earning_types_1.EarningType.PAID_HOLIDAY.value,
        earning_types_1.EarningType.PAID_HOLIDAY_1_5X.value,
        earning_types_1.EarningType.CASH_TIPS.value,
        earning_types_1.EarningType.PAYCHECK_TIPS.value,
        earning_types_1.EarningType.COMMISSION.value,
        earning_types_1.EarningType.BONUS.value,
    ];
    const TOTAL_GROSS_DEPENDENCY_TYPES = original.filter((type) => !exclude.includes(type));
    return earnings
        .filter((earning) => TOTAL_GROSS_DEPENDENCY_TYPES.includes(earning.type))
        .filter((earning) => (earning.type === earning_types_1.EarningType.BONUS.value && earning.subtype === earning_types_1.EarningSubType.NON_DISCRETIONARY.value) ||
        earning.type !== earning_types_1.EarningType.BONUS.value);
}
exports.getOvertimePayRateDependentEarnings = getOvertimePayRateDependentEarnings;
function calculateTotalHourlyEarningsGross(hourlyEarnings, payRate, payType) {
    return hourlyEarnings.reduce((total, earning) => {
        const hours = earning.minutes / 60;
        let hourlyRate = (0, toHourlyRate_1.default)(payType, earning.payRate || payRate);
        if (earning.type === earning_types_1.EarningType.PAID_HOLIDAY_1_5X.value) {
            hourlyRate = (0, currency_1.default)(hourlyRate).multiply(1.5).value;
        }
        const earningAmount = (0, currency_1.default)(hourlyRate, {}).multiply(hours);
        return total.add(earningAmount);
    }, (0, currency_1.default)(0, {})).value;
}
exports.calculateTotalHourlyEarningsGross = calculateTotalHourlyEarningsGross;
function calculateTotalNonHourlyEarningsGross(nonHourlyEarnings) {
    return nonHourlyEarnings.reduce((total, earning) => total.add(earning.amount), (0, currency_1.default)(0, {})).value;
}
exports.calculateTotalNonHourlyEarningsGross = calculateTotalNonHourlyEarningsGross;
function calculateOvertimeEarningsBaseRate(payRate, payType, earnings, exclude = []) {
    const hours = calculateOvertimeDependentTotalHours(earnings);
    if (!hours) {
        return 0;
    }
    const dependencies = getOvertimePayRateDependentEarnings(earnings, exclude);
    const dependencyGross = grossEarnings(payRate, payType, dependencies);
    return (0, currency_1.default)(dependencyGross, {}).divide(hours).value;
}
exports.calculateOvertimeEarningsBaseRate = calculateOvertimeEarningsBaseRate;
function calculateOvertimeEarningsGross(overtimeEarnings, allEarnings, payRate, payType, excludeFromBaseRate = []) {
    let grossOvertime = (0, currency_1.default)(0, {});
    if (overtimeEarnings.length) {
        let overtimeBaseRate = calculateOvertimeEarningsBaseRate(payRate, payType, allEarnings, excludeFromBaseRate);
        grossOvertime = overtimeEarnings.reduce((total, earning) => {
            const hours = earning.minutes / 60;
            let earningAmount;
            if (!overtimeBaseRate) {
                overtimeBaseRate = earning.payRate || (0, toHourlyRate_1.default)(payType, payRate);
            }
            if (earning.type === earning_types_1.EarningType.OVERTIME.value) {
                earningAmount = (0, currency_1.default)(1.5, {}).multiply(overtimeBaseRate).multiply(hours);
            }
            else if (earning.type === earning_types_1.EarningType.DOUBLE_OVERTIME.value) {
                earningAmount = (0, currency_1.default)(2, {}).multiply(overtimeBaseRate).multiply(hours);
            }
            return total.add(earningAmount);
        }, (0, currency_1.default)(0, {}));
    }
    return grossOvertime.value;
}
exports.calculateOvertimeEarningsGross = calculateOvertimeEarningsGross;
function grossEarnings(payRate, payType, earnings, excludeFromOvertimeBaseRate = []) {
    if (!earnings.length) {
        return 0;
    }
    const payTypesMap = {
        overtime: [],
        hourly: [],
        nonHourly: [],
    };
    earnings.forEach((earning) => {
        if (OVERTIME_EARNING_TYPES.includes(earning.type)) {
            payTypesMap.overtime.push(earning);
        }
        else if (HOURLY_EARNING_TYPES.includes(earning.type)) {
            payTypesMap.hourly.push(earning);
        }
        else if (NON_HOURLY_EARNING_TYPES.includes(earning.type)) {
            payTypesMap.nonHourly.push(earning);
        }
        else {
            payTypesMap.nonHourly.push(earning);
        }
    });
    const grossHourly = calculateTotalHourlyEarningsGross(payTypesMap.hourly, payRate, payType);
    const grossNonHourly = calculateTotalNonHourlyEarningsGross(payTypesMap.nonHourly);
    const grossOvertime = calculateOvertimeEarningsGross(payTypesMap.overtime, earnings, payRate, payType, excludeFromOvertimeBaseRate);
    return (0, currency_1.default)(grossHourly, {}).add(grossNonHourly).add(grossOvertime).value;
}
exports.grossEarnings = grossEarnings;
function calculateOvertimeEarningAmount(earningId, earnings, payRate, payType, excludeFromBaseRate = []) {
    const thisEarning = earnings.find((earning) => earning.id === earningId);
    return calculateOvertimeEarningsGross([thisEarning], earnings, payRate, payType, excludeFromBaseRate);
}
exports.calculateOvertimeEarningAmount = calculateOvertimeEarningAmount;
function calculateEarningAmount(earningId, earnings, payRate, payType, excludeFromOvertimeBaseRate = []) {
    const thisEarning = earnings.find((earning) => earning.id === earningId);
    const isOvertimeType = OVERTIME_EARNING_TYPES.includes(thisEarning === null || thisEarning === void 0 ? void 0 : thisEarning.type);
    if (isOvertimeType) {
        return calculateOvertimeEarningAmount(thisEarning.id, earnings, payRate, payType, excludeFromOvertimeBaseRate);
    }
    const isNonHourlyType = NON_HOURLY_EARNING_TYPES.includes(thisEarning === null || thisEarning === void 0 ? void 0 : thisEarning.type);
    if (isNonHourlyType) {
        return (0, currency_1.default)(thisEarning.amount || 0, {}).value;
    }
    return grossEarnings(payRate, payType, [thisEarning]);
}
exports.calculateEarningAmount = calculateEarningAmount;
function calculatePayrollTotalGross(staffItems) {
    return staffItems.reduce((total, { employee, contractor, entries, earnings, reimbursements, payType: staffPayType }) => {
        const staff = employee || contractor;
        const payType = staffPayType || staff.payType;
        const gross = grossEarnings(staff.payRate, payType, (0, union_1.default)(employee ? earnings : entries, reimbursements));
        return total.add(gross);
    }, (0, currency_1.default)(0, {})).value;
}
exports.calculatePayrollTotalGross = calculatePayrollTotalGross;
//# sourceMappingURL=grossEarnings.js.map